import { FC, useRef } from "react";
import { AdminAccountResDto } from "service/api/estabrookSchemas";
import WarningConfirmDialog from "./WarningConfirmDialog";

export interface ResendInviteConfirmDialogProps {
  member: AdminAccountResDto | null;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ResendInviteConfirmDialog: FC<ResendInviteConfirmDialogProps> = ({
  member,
  isSubmitting,
  onConfirm,
  onCancel,
}) => {
  const lastMemberRef = useRef<AdminAccountResDto | null>(null);
  if (member) lastMemberRef.current = member;

  const displayMember = member ?? lastMemberRef.current;

  return (
    <WarningConfirmDialog
      open={Boolean(member)}
      title="Resend Invitation"
      description={`Are you sure you want to resend the invitation to ${displayMember?.firstName} ${displayMember?.lastName}?`}
      confirmLabel="Resend"
      isSubmitting={isSubmitting}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmTestId="confirm-resend-invite"
      cancelTestId="cancel-resend-invite"
    />
  );
};

export default ResendInviteConfirmDialog;
